module.exports = __webpack_public_path__ + "img/编组 2.cf49bf0f.png";